import { useGetCampaignPrices } from "@/hooks/api/predictive/campaign/useGetCampaignPrices";
import Badge from "@/components/atoms/Badge";
import { FormControlProps } from "@/components/molecules/form/FormControl";
import FormRadio from "@/components/molecules/form/FormRadio";

type FormCampaignSubscriptionSelectProps = {
  name: string;
} & Omit<FormControlProps, "id" | "children">;

// TODO Translate
const FormCampaignSubscriptionSelect = ({ name, ...rest }: FormCampaignSubscriptionSelectProps) => {
  const { data } = useGetCampaignPrices();

  const formatter = new Intl.NumberFormat("de-AT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const formatPrice = (price: number) => formatter.format(price / 100);

  return (
    <FormRadio
      name={name}
      options={data?.[0].prices || []}
      renderOption={(opt) => (
        <span className="flex flex-1">
          <span className="flex flex-col gap-1">
            <span className="inline-flex items-center gap-2 font-semibold text-primary">
              {opt.interval_count === 1 ? (
                "Monthly"
              ) : (
                <>
                  Quarterly <Badge label={"-20%"} color={"success"} />
                </>
              )}
            </span>
            <div className={"flex gap-2"}>
              <span className="text-3xl font-bold text-brand-primary">
                {formatPrice(opt.unit_amount / opt.interval_count)}
              </span>
              <span className={"mb-1 self-end text-sm text-quaternary"}>/ per month</span>
            </div>
            <span className="mt-1 flex items-center text-sm text-quaternary">
              {opt.interval_count === 1 ? "Billed monthly" : `Billed ${formatPrice(opt.unit_amount)} per quarter`}
            </span>
          </span>
        </span>
      )}
      {...rest}
    />
  );
};

export default FormCampaignSubscriptionSelect;
